import { Component, Input, Output, EventEmitter, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

/**
 * Single color swatch backed by a native `<input type="color">`.
 * ControlValueAccessor — bind with `formControlName` or `[(ngModel)]`.
 * The value is a hex string (e.g. `#f8771a`).
 */
@Component({
  selector: 'kt-color-picker',
  templateUrl: './color-picker.component.html',
  styleUrls: ['./color-picker.component.scss'],
  providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => ColorPickerComponent), multi: true }]
})
export class ColorPickerComponent implements ControlValueAccessor {
  @Input() label = '';
  @Input() labelPosition: 'top' | 'left' | 'right' = 'top';
  @Input() tooltip = '';
  @Input() disabled = false;

  @Output() colorChange = new EventEmitter<string>();

  value = '#000000';

  onChange = (_: any) => { };
  onTouched = () => { };

  onColorInput(color: string) {
    this.value = color;
    this.onChange(color);
    this.onTouched();
    this.colorChange.emit(color);
  }

  writeValue(value: any) { this.value = value || '#000000'; }
  registerOnChange(fn: any) { this.onChange = fn; }
  registerOnTouched(fn: any) { this.onTouched = fn; }
  setDisabledState(isDisabled: boolean) { this.disabled = isDisabled; }
}
